import { render } from "./StatsView.vue?vue&type=template&id=2877b28f"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=2877b28f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__